import(/* webpackMode: "eager" */ "/vercel/path0/web-app/src/app/o/[slug]/page.tsx");
